import { createSelector } from 'reselect';

import {
  HYDRATE,
  type HydrateAction,
} from '@/domains/core/applicationState/store/hydrateAction';
import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import {
  GRAPHQL_SUCCESS,
  GraphqlSuccess,
} from '@/domains/productDiscovery/ProductPage/detail.actions';

export const CHANGE_QUANTITY = 'product/CHANGE_QUANTITY';

export interface ChangeQuantity {
  type: typeof CHANGE_QUANTITY;
  quantity: number;
}

export const SET_STOCK = 'product/SET_STOCK';

export interface SetStock {
  type: typeof SET_STOCK;
  stock: number;
}

export type Action = ChangeQuantity | SetStock | GraphqlSuccess;

export type QuantityState = {
  value: number;
  stock: number | null;
};

const initialState = {
  value: 1,
  stock: null,
};

export default function reducer(
  state: QuantityState = initialState,
  action: Action | HydrateAction<SpartacuxProductDiscoveryDomainState>,
): QuantityState {
  switch (action.type) {
    case CHANGE_QUANTITY:
      if (state.stock !== null) {
        return {
          value: Math.min(state.stock, action.quantity),
          stock: state.stock,
        };
      }
      return {
        value: action.quantity,
        stock: null,
      };

    case GRAPHQL_SUCCESS: {
      return {
        value:
          Number(action.payload?.mainData?.packaging?.minimumQuantity) || 1,
        stock: null,
      };
    }
    case SET_STOCK:
      return {
        value: Math.min(state.value, action.stock),
        stock: action.stock,
      };

    case HYDRATE:
      return stateSelector(action.state);

    default:
      return state;
  }
}

const stateSelector = (
  state: SpartacuxProductDiscoveryDomainState,
): QuantityState =>
  state.productDiscovery?.productPage?.quantity || initialState;

export const quantitySelector = createSelector(
  stateSelector,
  (state) => state.value,
);
export const stockSelector = createSelector(
  stateSelector,
  (state) => state.stock,
);
